<template>
  <div class="container">
    <div class="title"><h1>Education</h1></div>
    <div class="screen">
      <div class="school">
        <img
          class="testimg"
          src="../assets/cmu.png"
          alt="Carnegie Mellon University"
        />
        <div>
          <h2 class="degree">
            Master of <br />
            Human-Computer <br />Interaction
          </h2>
          <p>
            In <strong>August of 2020</strong>, I earned my Master’s degree from
            Carnegie Mellon’s School of Computer Science. The curriculum mixes
            <strong>Computer Science</strong> with <strong>Design</strong> as
            well as <strong>Behavioral Research</strong>.
          </p>
          <p>
            I took additional electives in
            <strong>Machine Learning</strong>, <strong>IoT Prototyping</strong>,
            and <strong>Visualization Methodology</strong>.
          </p>
        </div>
      </div>
      <div class="school">
        <img
          class="testimg"
          src="../assets/umd.jpg"
          alt="University of Maryland"
        />
        <div>
          <h2 class="degree">
            Bachelor of Science <br />
            Electrical <br />Engineering
          </h2>
          <p>
            In 2004, I completed my degree in
            <strong>Electrical Engineering</strong> from the University of
            Maryland's A James Clark School of Engineering with a concentration
            in <strong>Multimedia Signal Processing</strong>.
          </p>
          <p>
            I received citations in <strong>Music Studies</strong> and
            <strong>University Honors</strong> as well as serving as an officer
            of <strong>Eta Kappa Nu Honor Society</strong>.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Career",
};
</script>

<style scoped>
.container {
  width: 100%;
  min-height: 100%;
  scroll-snap-align: start;
  background-image: url("../assets/cmu-campus-bw.png");
  background-position: center;
  background-size: cover;
  background-color: black;
  position: relative;
}
.title {
  padding-top: 0px;
}
.title > h1 {
  margin-block-start: 0vh;
  margin-block-end: 0px;
}
.screen {
  margin: auto;
  width: 100vw;
  min-height: 90%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
}

.testimg {
  width: 100%;
  max-height: 25vh;
  max-width: 25vh;
  object-fit: contain;
  border-radius: 2.5%;
  margin-top: 1vh;
  margin-bottom: 1vh;
}
.school {
  scroll-snap-align: center;
  width: 100vw;
  max-width: 50vh;
  margin: 4vmin;
  background-color: #3a4959f0;
  padding: 25px;
}
h2 {
  font-weight: 500;
  margin-block-start: 0vh;
  margin-block-end: 0vh;
}
.degree {
  color: var(--gold);
  font-size: 4vh;
  line-height: 4.5vh;
  margin-block-end: 1.5vh;
}
p {
  max-width: 50vh;
  color: white;
  margin: auto;
  margin-block-end: 1vh;
}
.bottomspacer {
  height: 12vmin;
  max-height: 60px;
}
</style>
